import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = { hasPermission: boolean }

export const BulkReassignButton: React.FC<Props> = (props) => (
  <BulkActionButton
    type="reassign"
    helperText="Mass re-assign multiple records."
    hasPermission={props.hasPermission}
    errorString="You do not have permission to perform bulk updates."
  >
    Re-Assign
  </BulkActionButton>
)
BulkReassignButton.displayName = 'BulkReassignButton'
